module.exports = __webpack_public_path__ + "static/media/avatar-2.0164f485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/happy-customers/avatar-2.png
// module id = 2244
// module chunks = 0